import { isPageUrl } from "./../url/is-page-url";
const isPageLink = (link) => typeof link.url === "string" && isPageUrl(link?.url);
export {
  isPageLink
};
//# sourceMappingURL=is-page-link.js.map
